import { makeStyles } from '@mui/styles';
import { RegisterRootBackground } from '../../../assets/assetSelector';

const registerStyles = makeStyles((theme) => {
  return {
    root: {
      minHeight: `calc(100vh - ${
        theme.config.isTopNavbarFixed ? '0px' : '96px'
      })`,
      paddingTop: theme.config.isTopNavbarFixed ? '96px' : '0px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: `url(${RegisterRootBackground()})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      // backgroundAttachment: 'fixed',
    },
    registerCard: {
      margin: theme.spacing(3),
      minheight: '50vh',
      width: '95%',
      [theme.breakpoints.up('sm')]: {
        width: '450px',
      },
      background: theme.palette.specifics.registerCard,
      position: 'relative',
      color: theme.palette.primary.dark,
      '& a': {
        textDecoration: 'none',
      },
    },
    backdrop: {
      zIndex: 1,
      color: theme.palette.primary.dark,
    },
    grow: {
      flexGrow: 1,
    },
  };
});

export default registerStyles;
